// REACT & Libraries
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import DataTable from "react-data-table-component";
import FilterComponent from "../../Common/FilterComponent";

// Table
import { JobLevelTableColumn } from "../../../../Data/DataTables/JobLevel";

// Types
import { ViewJobLevel } from "../../../../Types/MasterData/JobLevel";

// Services
import {
  VIEW_JOBLEVEL_QUERY_KEY,
  joblevelService,
} from "../../../../Services/joblevelService";

const JobLevelTable = () => {
  const [filterText, setFilterText] = useState("");
  const { data: usersResponse, isLoading } = useQuery({
    queryKey: VIEW_JOBLEVEL_QUERY_KEY,
    queryFn: joblevelService.viewAllJobLevel,
  });

  const filteredItems: ViewJobLevel[] = usersResponse?.data.filter(
    (item: ViewJobLevel) =>
      Object.values(item).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(filterText.toLowerCase()),
      ),
  );

  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  return (
    <>
      <FilterComponent
        onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterText(e.target.value)
        }
        filterText={filterText}
      />
      <div className="table-responsive">
        <DataTable
          className="display nowrap custom-scrollbar"
          data={filteredItems}
          columns={JobLevelTableColumn}
          striped={true}
          pagination
          progressPending={isLoading}
          highlightOnHover={true}
          fixedHeader={true}
          customStyles={customStyles}
        />
      </div>
    </>
  );
};

export default JobLevelTable;
